/**
 * 시스템 > 장비 관리 > 장비 및 그룹 편집 Store
 *
 * @since 2018-04-02
 * @author devp021
 */
import { SystemApiPrefix as apiPrefix } from '~/utils/restApi'

export const state = () => ({
  failAlarmUrl: `${apiPrefix}/events`,
  processUrl: `${apiPrefix}/process-watch`,
  logUrl: `${apiPrefix}/log-watch`,
  deviceId: 1,
  isAddRowRsrcCpu0: null,
  isSelectRowRsrcCpu0: null,
  isMultiRowRsrcCpu0: null,
  isAddRowRsrcMemory0: null,
  isSelectRowRsrcMemory0: null,
  isMultiRowRsrcMemory0: null,
  isAddRowRsrcDisk0: null,
  isSelectRowRsrcDisk0: null,
  isMultiRowRsrcDisk0: null,
  isAddRowRsrcSession0: null,
  isSelectRowRsrcSession0: null,
  isMultiRowRsrcSession0: null,
  isAddRowRsrcTraffic0: null,
  isSelectRowRsrcTraffic0: null,
  isMultiRowRsrcTraffic0: null,
  isAddRowWatchProcess0: null,
  isSelectRowWatchProcess0: null,
  isMultiRowWatchProcess0: null,
  isAddRowWatchUserDefine0: null,
  isSelectRowWatchUserDefine0: null,
  isMultiRowWatchUserDefine0: null,
  rsrcCpuCode: 277011000,
  rsrcMemoryCode: 277013000,
  rsrcDiskCode: 1234567890,
  rsrcDiskLogCode: 277012010,
  rsrcDiskRootCode: 277012020,
  rsrcSessionCode: 277013100,
  rsrcTrafficCode: 277020030,
  eventLevelList: [{event_level_type: 1, event_level_color: '#FF0000'}],
  rsrcCpuList: [],
  rsrcMemoryList: [],
  rsrcDiskList: [],
  rsrcDiskLogList: [],
  rsrcDiskRootList: [],
  rsrcSessionList: [],
  rsrcTrafficList: [],
  failList: [],
  watchProcessList: [],
  watchMessageList: [],
  watchLogList: [],
  watchUserDefineList: [],
  delList: [],
  watchAPI: '',
  watchMode: '',

  deviceRsrcEvent: {device_id: '', device_rsrc_event_id: '', event_code: '', event_detect_type: 1, event_detect_ratio: 50, event_detect_cnt: 3, event_level_type: 1, event_use_yn: 1},
  eventDetectRatio1: '',
  eventDetectRatio2: '',
  deviceRsrcEventCntOption: [
    {label: '1', value: 1}, {label: '2', value: 2}, {label: '3', value: 3}, {label: '4', value: 4}, {label: '5', value: 5}, {label: '6', value: 6}, {label: '7', value: 7}, {label: '8', value: 8}, {label: '9', value: 9}, {label: '10', value: 10}, {label: '11', value: 11}, {label: '12', value: 12}, {label: '13', value: 13}, {label: '14', value: 14}, {label: '15', value: 15}, {label: '16', value: 16}, {label: '17', value: 17}, {label: '18', value: 18}, {label: '19', value: 19}, {label: '20', value: 20}, {label: '21', value: 21}, {label: '22', value: 22}, {label: '23', value: 23}, {label: '24', value: 24}, {label: '25', value: 25}, {label: '26', value: 26}, {label: '27', value: 27}, {label: '28', value: 28}, {label: '29', value: 29}, {label: '30', value: 30}, {label: '31', value: 31}, {label: '32', value: 32}, {label: '33', value: 33}, {label: '34', value: 34}, {label: '35', value: 35}, {label: '36', value: 36}, {label: '37', value: 37}, {label: '38', value: 38}, {label: '39', value: 39}, {label: '40', value: 40}, {label: '41', value: 41}, {label: '42', value: 42}, {label: '43', value: 43}, {label: '44', value: 44}, {label: '45', value: 45}, {label: '46', value: 46}, {label: '47', value: 47}, {label: '48', value: 48}, {label: '49', value: 49}, {label: '50', value: 50}, {label: '51', value: 51}, {label: '52', value: 52}, {label: '53', value: 53}, {label: '54', value: 54}, {label: '55', value: 55}, {label: '56', value: 56}, {label: '57', value: 57}, {label: '58', value: 58}, {label: '59', value: 59}, {label: '60', value: 60}
  ],

  deviceWatchEvent: {device_id: '', device_watch_event_id: '', event_code: '', device_watch_type: 0, device_watch_uname: '', event_level_type: 1, event_use_yn: 1},
  errorMessage: null,
  orgRsrc: {
    rsrcCpuList: [],
    rsrcMemoryList: [],
    rsrcDiskLogList: [],
    rsrcSessionList: [],
    rsrcTrafficList: []
  },
  cpuEventLevelTypeList: [],
  memoryEventLevelTypeList: [],
  diskLogEventLevelTypeList: [],
  diskRootEventLevelTypeList: [],
  sessionEventLevelTypeList: [],
  trafficEventLevelTypeList: [],
  eventType: {
    cpu: 'CPU',
    memory: 'MEMORY',
    disk: 'DISK',
    session: 'SESSION',
    traffic: 'TRAFFIC'
  }
})

export const mutations = {
  clearHistoryData (state) {
    state.watchProcessList = []
    state.watchUserDefineList = []
  },
  setWatchUserDefineList (state, list) {
    state.watchUserDefineList = list
  },
  setWatchProcessList (state, list) {
    state.watchProcessList = list

    if (state.watchProcessList.length === 100) {
      state.isAddRowWatchProcess0 = false
    } else {
      state.isAddRowWatchProcess0 = true
    }

    state.isSelectRowWatchProcess0 = false
    state.isMultiRowWatchProcess0 = false
  },
  setDeleteList (state, list) {
    state.delList = list
  },
  setDeviceId (state, data) {
    state.deviceId = data
  },
  setEventLevelList (state, res) { // ???
    state.eventLevelList = res // res.result
  },
  setRsrcCpuList (state, res) {
    state.rsrcCpuList = res
    state.orgRsrc.rsrcCpuList = _.cloneDeep(state.rsrcCpuList)
    state.cpuEventLevelTypeList = _.map(state.rsrcCpuList, 'event_level_type')

    if (state.rsrcCpuList.length === 3) {
      state.isAddRowRsrcCpu0 = false
    } else {
      state.isAddRowRsrcCpu0 = true
    }

    state.isSelectRowRsrcCpu0 = false
    state.isMultiRowRsrcCpu0 = false
  },
  setRsrcMemoryList (state, res) {
    state.rsrcMemoryList = res
    state.orgRsrc.rsrcMemoryList = _.cloneDeep(state.rsrcMemoryList)
    state.memoryEventLevelTypeList = _.map(state.rsrcMemoryList, 'event_level_type')

    if (state.rsrcMemoryList.length === 3) {
      state.isAddRowRsrcMemory0 = false
    } else {
      state.isAddRowRsrcMemory0 = true
    }

    state.isSelectRowRsrcMemory0 = false
    state.isMultiRowRsrcMemory0 = false
  },
  setRsrcDiskLogList (state, res) {
    state.rsrcDiskLogList = res
    state.diskLogEventLevelTypeList = _.map(state.rsrcDiskLogList, 'event_level_type')
    state.rsrcDiskList = state.rsrcDiskLogList
    state.orgRsrc.rsrcDiskList = _.cloneDeep(state.rsrcDiskList)

    if (state.rsrcDiskList.length === 6) {
      state.isAddRowRsrcDisk0 = false
    } else {
      state.isAddRowRsrcDisk0 = true
    }

    state.isSelectRowRsrcDisk0 = false
    state.isMultiRowRsrcDisk0 = false
  },
  setRsrcDiskRootList (state, res) {
    state.rsrcDiskRootList = res
    state.diskRootEventLevelTypeList = _.map(state.rsrcDiskRootList, 'event_level_type')
    state.rsrcDiskList = state.rsrcDiskLogList.concat(state.rsrcDiskRootList)
    state.orgRsrc.rsrcDiskList = _.cloneDeep(state.rsrcDiskList)

    if (state.rsrcDiskList.length === 6) {
      state.isAddRowRsrcDisk0 = false
    } else {
      state.isAddRowRsrcDisk0 = true
    }

    state.isSelectRowRsrcDisk0 = false
    state.isMultiRowRsrcDisk0 = false
  },
  setRsrcSessionList (state, res) {
    state.rsrcSessionList = res
    state.orgRsrc.rsrcSessionList = _.cloneDeep(state.rsrcSessionList)
    state.sessionEventLevelTypeList = _.map(state.rsrcSessionList, 'event_level_type')

    if (state.rsrcSessionList.length === 3) {
      state.isAddRowRsrcSession0 = false
    } else {
      state.isAddRowRsrcSession0 = true
    }

    state.isSelectRowRsrcSession0 = false
    state.isMultiRowRsrcSession0 = false
  },
  setRsrcTrafficList (state, res) {
    state.rsrcTrafficList = res
    state.orgRsrc.rsrcTrafficList = _.cloneDeep(state.rsrcTrafficList)
    state.trafficEventLevelTypeList = _.map(state.rsrcTrafficList, 'event_level_type')

    if (state.rsrcTrafficList.length === 3) {
      state.isAddRowRsrcTraffic0 = false
    } else {
      state.isAddRowRsrcTraffic0 = true
    }

    state.isSelectRowRsrcTraffic0 = false
    state.isMultiRowRsrcTraffic0 = false
  },
  setFailList (state, res) {
    state.failList = res // res.result
  },
  setWatchMessageList (state, res) {
    state.watchMessageList = res
  },
  setWatchLogList (state, res) {
    state.watchLogList = res
    state.watchUserDefineList = _.concat(state.watchMessageList, state.watchLogList)

    if (state.watchUserDefineList.length === 100) {
      state.isAddRowWatchUserDefine0 = false
    } else {
      state.isAddRowWatchUserDefine0 = true
    }

    state.isSelectRowWatchUserDefine0 = false
    state.isMultiRowWatchUserDefine0 = false
  },

  dataInitRsrc (state, {eventCode, eventLevel}) {
    state.deviceRsrcEvent = {
      device_id: state.deviceId,
      device_rsrc_event_id: '',
      event_code: eventCode,
      event_detect_type: 1,
      event_detect_ratio: 90,
      event_detect_cnt: 3,
      event_level_type: eventLevel,
      event_use_yn: 1
    }
  },
  dataUpdateRsrc (state, list) {
    state.deviceRsrcEvent = list
  },
  dataInitWatch (state, payload) {
    state.deviceWatchEvent = {
      device_id: payload.deviceId,
      device_watch_event_id: '',
      event_code: '',
      device_watch_type: 0,
      device_watch_uname: '',
      event_level_type: 3,
      event_use_yn: 1
    }

    if (payload.watchMode === 'process') {
      state.watchMode = 'process'
      state.watchAPI = `/api/sm/process-watch/${payload.deviceId}` // watchAPI. computed vs js. this vs state.
      state.deviceWatchEvent.device_watch_type = 1
    } else if (payload.watchMode === 'user') {
      state.watchMode = 'user'
      state.watchAPI = `/api/sm/log-watch/${payload.deviceId}`
      state.deviceWatchEvent.device_watch_type = 2
    }
  },
  dataUpdateWatch (state, payload) {
    state.deviceWatchEvent = _.cloneDeep(payload.list)

    if (payload.watchMode === 'process') {
      state.watchMode = 'process'
      state.watchAPI = `/api/sm/process-watch/${payload.list.device_watch_event_id}`
    } else if (payload.watchMode === 'user') {
      state.watchMode = 'user'
      state.watchAPI = `/api/sm/log-watch/${payload.list.device_watch_event_id}`
    }
  },
  initErrorMessage (state) {
    state.errorMessage = ''
  },
  setErrorMessage (state, data) {
    const msg = {
      error: data.msg
    }
    state.errorMessage = msg
  },
  setDataRestore (state, type) {
    switch (type) {
      case state.eventType.cpu :
      case state.rsrcCpuCode.toString() :
        state.rsrcCpuList = _.cloneDeep(state.orgRsrc.rsrcCpuList)
        break
      case state.eventType.memory :
      case state.rsrcMemoryCode.toString() :
        state.rsrcMemoryList = _.cloneDeep(state.orgRsrc.rsrcMemoryList)
        break
      case state.eventType.disk :
      case state.rsrcDiskCode.toString() :
      case state.rsrcDiskLogCode.toString() :
      case state.rsrcDiskRootCode.toString() :
        state.rsrcDiskList = _.cloneDeep(state.orgRsrc.rsrcDiskList)
        break
      case state.eventType.session :
      case state.rsrcSessionCode.toString() :
        state.rsrcSessionList = _.cloneDeep(state.orgRsrc.rsrcSessionList)
        break
      case state.eventType.traffic :
      case state.rsrcTrafficCode.toString() :
        state.rsrcTrafficList = _.cloneDeep(state.orgRsrc.rsrcTrafficList)
        break
      default :
        break
    }
  }
}

export const actions = {
  // 현재 범위 참조 : dispatch
  // mutation 범위 참조 : commit
  async getEventLevelList ({commit}) {
    const res = {code: 'ok'}
    commit('initErrorMessage')
    try {
      const {code, result} = await this.$axios.$get('/api/sm/event-level')
      if (code.toLowerCase() === 'ok') {
        commit('setEventLevelList', result)
        res.reason = 'SUCCESS'
      } else {
        commit('setErrorMessage', result)
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async getRsrcList ({commit, state}, {eventCode, load = true}) {
    try {
      commit('initErrorMessage')
      const {code, result} = await this.$axios.$get(`/api/sm/alarm/${state.deviceId}?event_code=${eventCode}`, {loading: load, successAlert: load})
      if (code.toLowerCase() === 'ok') {
        if (eventCode === state.rsrcCpuCode) {
          commit('setRsrcCpuList', result)
        } else if (eventCode === state.rsrcMemoryCode) {
          commit('setRsrcMemoryList', result)
        } else if (eventCode === state.rsrcDiskLogCode) {
          commit('setRsrcDiskLogList', result)
        } else if (eventCode === state.rsrcDiskRootCode) {
          commit('setRsrcDiskRootList', result)
        } else if (eventCode === state.rsrcSessionCode) {
          commit('setRsrcSessionList', result)
        } else if (eventCode === state.rsrcTrafficCode) {
          commit('setRsrcTrafficList', result)
        }
        return true
      } else {
        commit('setErrorMessage', result)
        return false
      }
    } catch (e) {}
  },
  async getRsrcDiskOverFlowAlarmList ({ commit, state, rootState }) {
    try {
      commit('initErrorMessage')
      const ccFlag = rootState.common.common.uiData.system.cc_flag

      const logRes = await this.$axios.$get(`/api/sm/alarm/${state.deviceId}?event_code=${state.rsrcDiskLogCode}`, {loading: false, successAlert: false})
      if (logRes.code !== 'ok') {
        commit('setErrorMessage', logRes.result)
        return logRes
      }
      if (ccFlag) {
        commit('setRsrcDiskLogList', logRes.result)
      } else {
        const rootRes = await this.$axios.$get(`/api/sm/alarm/${state.deviceId}?event_code=${state.rsrcDiskRootCode}`, {
          loading: false,
          successAlert: false
        })
        commit('setRsrcDiskLogList', logRes.result)
        if (rootRes.code === 'ok') commit('setRsrcDiskRootList', rootRes.result)
      }
    } catch (e) {
      return {
        code: 'nok',
        result: { msg: e.message }
      }
    }
    return {code: 'ok', result: {}}
  },
  // {loading: load, successAlert: load}  =>  {isNotAlert: load}
  async getFailList ({commit, state}, load = true) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$get(`/api/sm/events/${state.deviceId}`, {loading: load, successAlert: load})
    if (code.toLowerCase() === 'ok') {
      commit('setFailList', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async getWatchProcessList ({commit, state}) {
    const res = {code: 'ok'}
    commit('initErrorMessage')
    try {
      const {code, result} = await this.$axios.$get(`/api/sm/process-watch/${state.deviceId}?device_watch_type=1`)
      if (code.toLowerCase() === 'ok') {
        commit('setWatchProcessList', result)
        res.reason = 'SUCCESS'
      } else {
        commit('setErrorMessage', result)
        res.reason = 'FAIL'
      }

      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async getWatchMessageList ({commit, state}, load = true) {
    const res = {code: 'ok'}
    commit('initErrorMessage')
    try {
      const {code, result} = await this.$axios.$get(`/api/sm/log-watch/${state.deviceId}/2`, {loading: load, successAlert: load})
      if (code.toLowerCase() === 'ok') {
        commit('setWatchMessageList', result)
        res.reason = 'SUCCESS'
      } else {
        commit('setErrorMessage', result)
        res.reason = 'FAIL'
      }

      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async getWatchLogList ({commit, state}, load = true) {
    const res = {code: 'ok'}
    commit('initErrorMessage')
    try {
      const {code, result} = await this.$axios.$get(`/api/sm/log-watch/${state.deviceId}/3`, {loading: load, successAlert: load})
      if (code.toLowerCase() === 'ok') {
        commit('setWatchLogList', result)
        res.reason = 'SUCCESS'
      } else {
        commit('setErrorMessage', result)
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async getWatchUserDefineList ({ commit, state }, load = true) {
    const res = {
      code: 'ok',
      result: {}
    }
    try {
      commit('initErrorMessage')
      let res = void 0
      res = await this.$axios.$get(`/api/sm/log-watch/${state.deviceId}/2`, {loading: load, successAlert: load})
      if (res.code === 'ok') {
        commit('setWatchMessageList', res.result)
        res.reason = 'SUCCESS'

        res = await this.$axios.$get(`/api/sm/log-watch/${state.deviceId}/3`, {loading: load, successAlert: load})
        if (res.code === 'ok') {
          commit('setWatchLogList', res.result)
          res.reason = 'SUCCESS'
        } else {
          commit('setErrorMessage', res.result)
          res.reason = 'FAIL'
        }
      } else {
        commit('setErrorMessage', res.result)
        res.reason = 'FAIL'
      }
    } catch (e) {
      res.code = 'nok'
      res.result = e.message
    }
    return res
  },
  async onRsrcCpuUseChkAxios ({commit, state, dispatch}, list) {
    try {
      commit('initErrorMessage')
      const { code, result } = await this.$axios.$put('/api/sm/alarm/use', {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
      if (code === 'ok') {
        await dispatch('getRsrcList', {eventCode: state.rsrcCpuCode, load: false})
      } else {
        commit('setErrorMessage', result)
      }
    } catch (e) {}
  },
  async onRsrcCpuLevelChangeAxios ({commit}, list) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put('/api/sm/alarm/levels', {rsrc_event_id_list: list}, {loading: false, successAlert: false})
    if (code === 'ok') {
      // dispatch('getRsrcList', state.rsrcCpuCode)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async onRsrcMemoryUseChkAxios ({commit, state, dispatch}, list) {
    try {
      commit('initErrorMessage')
      const {code, result} = await this.$axios.$put(`/api/sm/alarm/use`, {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
      if (code === 'ok') {
        await dispatch('getRsrcList', {eventCode: state.rsrcMemoryCode, load: false})
      } else {
        commit('setErrorMessage', result)
      }
    } catch (e) {}
  },
  async onRsrcMemoryLevelChangeAxios ({commit}, list) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put('/api/sm/alarm/levels', {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
    if (code === 'ok') {
      // dispatch('getRsrcList', state.rsrcMemoryCode)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async onRsrcDiskUseChkAxios ({commit, state, dispatch, rootState}, list) {
    try {
      commit('initErrorMessage')
      const ccFlag = rootState.common.common.uiData.system.cc_flag
      const res = await this.$axios.$put(`/api/sm/alarm/use`, {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
      if (res.code !== 'ok') {
        commit('setErrorMessage', res.result)
        return
      }
      // 디스크 수정 후 재조회
      const logRes = await this.$axios.$get(`/api/sm/alarm/${state.deviceId}?event_code=${state.rsrcDiskLogCode}`, {loading: false, successAlert: false})
      if (logRes.code !== 'ok') {
        commit('setErrorMessage', logRes.result)
        return
      }
      if (ccFlag) {
        commit('setRsrcDiskLogList', logRes.result)
      } else {
        const rootRes = await this.$axios.$get(`/api/sm/alarm/${state.deviceId}?event_code=${state.rsrcDiskRootCode}`, {loading: false, successAlert: false})
        commit('setRsrcDiskLogList', logRes.result)
        if (rootRes.code.toLowerCase() === 'ok') commit('setRsrcDiskRootList', rootRes.result)
        else commit('setErrorMessage', rootRes.result)
      }
    } catch (e) {}
  },
  // async onRsrcDiskLevelChangeAxios ({commit}, {list, eventCode}) {
  async onRsrcDiskLevelChangeAxios ({commit}, list) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put('/api/sm/alarm/levels', {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async onRsrcSessionUseChkAxios ({commit, state, dispatch}, list) {
    try {
      commit('initErrorMessage')
      const {code, result} = await this.$axios.$put(`/api/sm/alarm/use`, {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
      if (code === 'ok') {
        await dispatch('getRsrcList', {eventCode: state.rsrcSessionCode, load: false})
      } else {
        commit('setErrorMessage', result)
      }
    } catch (e) {}
  },
  async onRsrcSessionLevelChangeAxios ({commit}, list) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put('/api/sm/alarm/levels', {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
    if (code === 'ok') {
      // dispatch('getRsrcList', state.rsrcSessionCode)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async onRsrcTrafficUseChkAxios ({commit, state, dispatch}, list) {
    try {
      commit('initErrorMessage')
      const {code, result} = await this.$axios.$put(`/api/sm/alarm/use`, {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
      if (code === 'ok') {
        await dispatch('getRsrcList', {eventCode: state.rsrcTrafficCode, load: false})
      } else {
        commit('setErrorMessage', result)
      }
    } catch (e) {}
  },
  async onRsrcTrafficLevelChangeAxios ({commit}, list) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put('/api/sm/alarm/levels', {rsrc_event_id_list: list}, {loading: false, successAlert: false}) // headers)
    if (code === 'ok') {
      // dispatch('getRsrcList', state.rsrcTrafficCode)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async onFailAlarmChkUse ({commit, state, dispatch}, data) {
    try {
      commit('initErrorMessage')
      const {code, result} = await this.$axios.$put(`${state.failAlarmUrl}/${state.deviceId}`, data, {loading: false, successAlert: false})
      if (code === 'ok') {
        await dispatch('getFailList', false)
      }
      commit('setErrorMessage', result)
    } catch (e) {}
  },
  async onProcessChkUse ({commit, state, dispatch}, data) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put(`${state.processUrl}/use/${state.deviceId}`, data, {loading: false, successAlert: false})
    if (code === 'ok') {
      // dispatch('getWatchProcessList', false)
      return true
    } else {
      dispatch('getWatchProcessList', false)
    }
    commit('setErrorMessage', result)
    return false
  },
  async onProcessChkInputAxios ({commit, state, dispatch}) {
    commit('initErrorMessage')
    const deviceWatchProcessEventIdList = []
    for (let i = 0; i < state.watchProcessList.length; i++) {
      deviceWatchProcessEventIdList.push([state.watchProcessList[i].device_watch_event_id, state.watchProcessList[i].event_use_yn])
    }

    await this.$axios.$put(`/api/sm/process-watch/use/${state.deviceId}`, {watch_event_id_list: deviceWatchProcessEventIdList}, {loading: false, successAlert: false}) // headers)
      .then((res) => {
        if (res.code === 'ok') {
          dispatch('getWatchProcessList', false)
        } else {
          commit('setErrorMessage', res.result)
        }
      })
  },
  // 추후 프로세스 감시 알람, 사용자 정의 로그 감시 알람 등급 API와 합칠 것
  async onProcessChkInput2Axios ({commit, state, dispatch}, params) {
    commit('initErrorMessage')

    await this.$axios.$put('/api/sm/process-watch/levels', params, {loading: false, successAlert: false})
      .then((res) => {
        if (res.code === 'ok') {
          dispatch('getWatchProcessList', false)
        } else {
          commit('setErrorMessage', res.result)
        }
      })
  },
  async onUserDefineChkUse ({commit, state, dispatch}, data) {
    commit('initErrorMessage')
    const {code, result} = await this.$axios.$put(`${state.logUrl}/use/${state.deviceId}`, data, {loading: false, successAlert: false})
    if (code === 'ok') {
      return true
    } else {
      dispatch('getWatchUserDefineList', false)
    }
    commit('setErrorMessage', result)
    return false
  },
  async onUserDefineChkInputAxios ({commit, state, dispatch}) {
    commit('initErrorMessage')
    const deviceWatchUserDefineEventIdList = []
    for (let i = 0; i < state.watchUserDefineList.length; i++) {
      deviceWatchUserDefineEventIdList.push([state.watchUserDefineList[i].device_watch_event_id, state.watchUserDefineList[i].event_use_yn])
    }

    await this.$axios.$put(`/api/sm/log-watch/use/${state.deviceId}`, {watch_event_id_list: deviceWatchUserDefineEventIdList}, {loading: false, successAlert: false})
      .then((res) => {
        if (res.code === 'ok') {
          dispatch('getWatchUserDefineList', false)
        } else {
          commit('setErrorMessage', res.result)
        }
      })
  },
  // 추후 프로세스 감시 알람, 사용자 정의 로그 감시 알람 등급 API와 합칠 것
  async onUserDefineChkInput2Axios ({commit, state, dispatch}, params) {
    commit('initErrorMessage')

    await this.$axios.$put('/api/sm/log-watch/levels', params, {loading: false, successAlert: false})
      .then((res) => {
        if (res.code === 'ok') {
          dispatch('getWatchUserDefineList', false)
        } else {
          commit('setErrorMessage', res.result)
        }
      })
  },
  async getRsrcAdd ({commit, state}, deviceRsrcEventJson) {
    commit('initErrorMessage')
    const headers = { headers: { 'Content-Type': 'application/json' } }
    const {code, result} = await this.$axios.$post(`/api/sm/alarm/${state.deviceRsrcEvent.device_id}`, deviceRsrcEventJson, headers)
    if (code.toLowerCase() === 'ok') {
      return true
    } else {
      commit('setErrorMessage', result)
      return false
    }
  },
  async getRsrcUpdate ({commit, state}, deviceRsrcEventJson) {
    commit('initErrorMessage')
    const headers = { headers: { 'Content-Type': 'application/json' } }
    const {code, result} = await this.$axios.$put(`/api/sm/alarm/${state.deviceRsrcEvent.device_rsrc_event_id}`, deviceRsrcEventJson, headers)
    if (code.toLowerCase() === 'ok') {
      return true
    } else {
      commit('setErrorMessage', result)
      return false
    }
  },
  async setWatchAdd ({commit, state, dispatch}, deviceWatchEventJson) {
    commit('initErrorMessage')

    const headers = { headers: { 'Content-Type': 'application/json' } }
    const {code, result} = await this.$axios.$post(state.watchAPI, deviceWatchEventJson, headers)
    if (state.watchMode === 'process') {
      dispatch('getWatchProcessList', false)
    } else if (state.watchMode === 'user') {
      dispatch('getWatchUserDefineList', false)
    }
    if (code.toLowerCase() === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async setWatchUpdate ({commit, state, dispatch}, deviceWatchEventJson) {
    commit('initErrorMessage')
    const headers = { headers: { 'Content-Type': 'application/json' } }
    const {code, result} = await this.$axios.$put(state.watchAPI, deviceWatchEventJson, headers)
    if (state.watchMode === 'process') {
      dispatch('getWatchProcessList', false)
    } else if (state.watchMode === 'user') {
      dispatch('getWatchUserDefineList', false)
    }
    if (code.toLowerCase() === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },

  async onRsrcDeleteCommand ({commit, state}) {
    let resultFlug = false
    commit('initErrorMessage')
    for (let i = 0; i < state.delList.length; i++) {
      const item = state.delList[i]
      const {code, result} = await this.$axios.$delete(`/api/sm/alarm/${item.device_rsrc_event_id}`)
      if (code === 'ok') {
        resultFlug = true
      } else {
        resultFlug = false
        commit('setErrorMessage', result)
      }
    }
    return resultFlug
  },
  async onWatchProcessDeleteCommand ({commit, state}) {
    commit('initErrorMessage')
    let resultFlug = false
    for (let i = 0; i < state.delList.length; i++) {
      const item = state.delList[i]
      const {code, result} = await this.$axios.$delete(`/api/sm/process-watch/${item.device_watch_event_id}`)
      if (code === 'ok') {
        resultFlug = true
      } else {
        resultFlug = false
        commit('setErrorMessage', result)
      }
    }
    return resultFlug
  },
  async onWatchUserDefineDeleteCommand ({commit, state}) {
    commit('initErrorMessage')
    let resultFlug = false
    for (let i = 0; i < state.delList.length; i++) {
      const item = state.delList[i]
      const {code, result} = await this.$axios.$delete(`/api/sm/log-watch/${item.device_watch_event_id}/${item.device_watch_type}`)
      if (code === 'ok') {
        resultFlug = true
      } else {
        resultFlug = false
        commit('setErrorMessage', result)
      }
    }
    return resultFlug
  },

  async applyFail ({commit}) {
    commit('initErrorMessage')
  }
}

export const getters = {}

export const strict = false
